import { DiscBase, DiscBaseProps } from "./DiscBase";
import type { ButtonHTMLAttributes } from "react";

export type DiscButtonProps = {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  children: React.ReactNode;
} & DiscBaseProps &
  ButtonHTMLAttributes<HTMLButtonElement>;

export function DiscButton({ className, colors, image, noiseOpacity, onClick, children, ...rest }: DiscButtonProps) {
  return (
    <DiscBase
      className={className}
      image={image}
      colors={colors}
      noiseOpacity={noiseOpacity}
      showShadow={false}
      animate
      onClick={onClick}
      {...rest}
    >
      {children}
    </DiscBase>
  );
}
